import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useSeo } from "@/lib/seo";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  useSeo({ title: "Administration", robots: "noindex,nofollow" });
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Bienvenue");
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-anthracite px-6">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="mb-2 flex items-baseline justify-center gap-2">
            <span className="font-serif text-3xl font-semibold text-ivory">RSTI</span>
            <span className="text-[10px] uppercase tracking-[0.3em] text-champagne">Global</span>
          </div>
          <p className="text-sm text-ivory/50">Espace administrateur</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-4 bg-white p-8">
          <div>
            <label className="mb-1.5 block text-xs uppercase tracking-[0.15em] text-anthracite/50">Email</label>
            <input
              type="email" required data-testid="login-email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-tertiary px-4 py-3 text-sm outline-none focus:border-champagne focus:ring-1 focus:ring-champagne"
            />
          </div>
          <div>
            <label className="mb-1.5 block text-xs uppercase tracking-[0.15em] text-anthracite/50">Mot de passe</label>
            <input
              type="password" required data-testid="login-password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-tertiary px-4 py-3 text-sm outline-none focus:border-champagne focus:ring-1 focus:ring-champagne"
            />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-destructive">{error}</p>}
          <button
            type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-anthracite py-3.5 text-sm font-medium text-ivory transition-colors hover:bg-black disabled:opacity-50"
          >
            {loading ? "…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
